export const getVoiceAnalysesData = state => state.voiceAnalyses.all;
export const getVoiceAnalysisData = state => state.voiceAnalyses.voiceAnalysis;
export const voiceAnalysesIsFetching = state => state.voiceAnalyses.loading.all;
export const voiceAnalysisIsFetching = state => state.voiceAnalyses.loading.voiceAnalysis;